var _rect, _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 830,
    viewBox: "0 0 1600 830",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1841_321)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 830,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3885 0H0V830H3885V0Z",
    fill: "url(#paint0_radial_1841_321)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.35
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1603.61 598.864L1599.45 598.794C1599.16 546.279 1598.87 493.971 1598.57 441.87L1602.71 441.773C1603.02 493.933 1603.32 546.296 1603.61 598.864Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.23 671.537L1535.18 671.388C1534.97 601.72 1534.76 532.414 1534.55 463.47L1538.56 463.4C1538.78 532.42 1539 601.799 1539.23 671.537Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.58 717.22L1472.67 717.028C1472.61 636.446 1472.56 556.353 1472.5 476.747L1476.38 476.686C1476.45 556.379 1476.52 636.557 1476.58 717.22Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.92 681.651L1412.12 681.494C1412.25 600.036 1412.38 519.08 1412.52 438.628L1416.27 438.531C1416.13 519.072 1416.01 600.112 1415.92 681.651Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.47 589.67L1353.81 589.609C1354.16 497.448 1354.51 405.919 1354.86 315.02L1358.47 314.801C1358.14 405.793 1357.81 497.416 1357.47 589.67Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.41 647.728L1296.9 647.605C1297.41 561.509 1297.92 475.962 1298.43 390.963L1301.93 390.832C1301.39 475.906 1300.88 561.538 1300.41 647.728Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.8 712.261L1241.35 712.086C1241.94 635.18 1242.55 558.714 1243.19 482.689H1246.61C1246.01 558.749 1245.41 635.273 1244.8 712.261Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.02 734.484L1187.68 734.291C1188.1 692.023 1188.52 649.892 1188.95 607.898L1192.28 607.977C1191.86 650.018 1191.44 692.187 1191.02 734.484Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.32 793.769L1135.06 793.515C1137.04 629.349 1138.98 467.196 1140.89 307.056L1144.1 306.846C1142.2 467.144 1140.27 629.452 1138.32 793.769Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.11 621.447L1086.96 621.359C1089.06 470.046 1091.14 320.445 1093.19 172.556L1096.29 172.223C1094.25 320.264 1092.19 470.005 1090.11 621.447Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.96 386.495L1041.94 386.627C1042.44 354.728 1042.94 322.909 1043.44 291.168L1046.45 290.949C1045.96 322.725 1045.47 354.574 1044.96 386.495Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.445 474.88H993.492C994.661 408.712 995.829 342.867 996.998 277.347L999.925 277.119C998.756 342.727 997.596 408.647 996.445 474.88Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.76 467.632L947.895 467.693C949.297 394.607 950.696 321.927 952.092 249.654L954.931 249.408C953.558 321.752 952.168 394.493 950.76 467.632Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.739 346.883L905.961 347.05C906.609 316.162 907.255 285.347 907.898 254.606L910.667 254.369C910.03 285.14 909.387 315.978 908.739 346.883Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.653 434.561L860.945 434.649C862.114 383.821 863.256 333.213 864.372 282.825L867.071 282.605C865.943 333.065 864.804 383.716 863.653 434.561Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.16 451.579L818.531 451.649C819.25 421.749 819.968 391.922 820.687 362.168L823.316 362.027C822.603 391.805 821.885 421.656 821.16 451.579Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.13 452.823L777.562 452.884C778.895 401.006 780.224 349.334 781.55 297.871L784.1 297.678C782.785 349.188 781.462 400.904 780.13 452.823Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.576 476.15L737.078 476.203C738.247 432.474 739.433 388.897 740.636 345.472L743.134 345.314C741.953 388.78 740.767 432.392 739.576 476.15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.027 533.392H696.582C698.288 473.72 699.997 414.308 701.709 355.156L704.136 355.016C702.436 414.203 700.733 473.662 699.027 533.392Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.395 521.8H659.012C659.514 505.249 660.014 488.722 660.51 472.218L662.885 472.174C662.365 488.701 661.869 505.244 661.395 521.8Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.604 577.27L620.281 577.226C621.806 528.912 623.325 480.775 624.838 432.816L627.152 432.746C625.639 480.746 624.123 528.92 622.604 577.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.91 593.079L583.641 593.027C585.241 544.425 586.836 495.999 588.425 447.749L590.678 447.688C589.1 495.979 587.511 544.443 585.91 593.079Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.236 603.895L548.027 603.833C549.237 568.482 550.443 533.219 551.647 498.043H553.855C552.657 533.213 551.451 568.497 550.236 603.895Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.335 531.877H516.18C517.038 507.708 517.897 483.588 518.756 459.518L520.903 459.457C520.044 483.544 519.188 507.684 518.335 531.877Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.353 598.53L480.25 598.477C482.073 548.912 483.89 499.546 485.701 450.378L487.795 450.316C485.99 499.525 484.176 548.93 482.353 598.53Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.73 593.378L447.68 593.325C448.2 579.614 448.72 565.911 449.24 552.217H451.299C450.773 565.928 450.25 579.649 449.73 593.378Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.996 611.167L414.98 611.105C415.641 594.367 416.298 577.65 416.952 560.953H418.959C418.305 577.673 417.65 594.411 416.996 611.167Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.799 756.814L377.836 756.638C381.055 677.103 384.251 598.04 387.423 519.451H389.377C386.205 598.099 383.012 677.22 379.799 756.814Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.65 717.799L348.73 717.659C349.665 695.161 350.6 672.704 351.535 650.287L353.454 650.383C352.519 672.794 351.584 695.266 350.65 717.799Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.701 739.786L317.816 739.628C318.71 718.731 319.601 697.857 320.489 677.006L322.365 677.111C321.482 697.968 320.594 718.859 319.701 739.786Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.379 761.467L287.539 761.301C289.128 724.997 290.714 688.796 292.298 652.697L294.129 652.785C292.552 688.907 290.968 725.135 289.379 761.467Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.222 770.589L258.426 770.414C259.822 739.357 261.213 708.37 262.597 677.453L264.394 677.558C263.009 708.493 261.619 739.503 260.222 770.589Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.159 856.496L226.406 856.268C228.276 815.502 230.142 774.863 232.006 734.354L233.759 734.494C231.901 775.027 230.034 815.694 228.159 856.496Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.647 833.328L199.895 833.109C201.256 804.067 202.617 775.087 203.978 746.168L205.731 746.317C204.376 775.253 203.014 804.257 201.647 833.328Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.405 859.711L171.723 859.483C175.059 789.902 178.38 720.672 181.687 651.793L183.36 651.881C180.065 720.813 176.747 790.089 173.405 859.711Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.437 788.932L148.789 788.748C151.173 740.007 153.55 691.444 155.922 643.059L157.561 643.137L150.437 788.932Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.081 719.621L126.469 719.489C127.386 701.104 128.303 682.739 129.22 664.395L130.833 664.491C129.921 682.841 129.004 701.218 128.081 719.621Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.851 720.189L101.273 720.058C102.559 694.65 103.847 669.289 105.138 643.975L106.715 644.054C105.43 669.379 104.142 694.758 102.851 720.189Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2376 737.98L75.6953 737.84C77.5298 702.571 79.3525 667.395 81.1636 632.312L82.7059 632.374C80.8949 667.491 79.0721 702.693 77.2376 737.98Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3481 750.599L50.832 750.459C52.0005 728.259 53.1689 706.117 54.3373 684.033L55.8446 684.13C54.682 706.272 53.5165 728.428 52.3481 750.599Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8091 765.637L26.3281 765.479C28.3846 727.043 30.4293 688.716 32.4624 650.496L33.9434 650.575C31.9396 688.818 29.8948 727.172 27.8091 765.637Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18127 718.011L5.72656 717.889C6.33999 706.59 6.95636 695.303 7.57563 684.027L9.02157 684.124L7.18127 718.011Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.13 543.972L1580.52 543.831C1580.45 528.058 1580.38 512.284 1580.3 496.51L1621.83 496.15C1621.93 512.07 1622.03 528.011 1622.13 543.972Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.24 598.995L1516.93 598.268C1516.88 577.329 1516.83 556.429 1516.78 535.566L1557 535.628C1557.08 556.689 1557.16 577.811 1557.24 598.995Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1494.19 633.383L1455.13 632.314V559.842L1494.09 560.157C1494.12 584.519 1494.16 608.928 1494.19 633.383Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.09 596.726L1395.33 596.042C1395.38 571.581 1395.44 547.163 1395.5 522.79L1433.18 522.711C1433.14 547.336 1433.11 572.007 1433.09 596.726Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.3 493.064L1337.87 493.433C1337.99 465.77 1338.12 438.16 1338.24 410.602L1374.55 409.393C1374.48 437.225 1374.39 465.115 1374.3 493.064Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.94 557.755L1281.56 557.484C1281.72 531.626 1281.89 505.818 1282.07 480.06L1317.35 479.561C1317.21 505.576 1317.08 531.641 1316.94 557.755Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261 632.245L1226.63 631.246C1226.83 608.14 1227.03 585.063 1227.22 562.016L1261.53 562.322C1261.35 585.604 1261.17 608.911 1261 632.245Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.59 691.011L1173.16 689.46C1173.3 676.736 1173.43 664.023 1173.56 651.322L1206.95 652.505C1206.82 665.323 1206.71 678.158 1206.59 691.011Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155 622.436L1122.64 621.56C1123.25 572.486 1123.86 523.56 1124.48 474.784L1156.67 474.258C1156.11 523.472 1155.55 572.865 1155 622.436Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.41 462.867L1075.17 463.489C1075.82 418.188 1076.47 373.046 1077.12 328.061L1108.22 326.186C1107.62 371.591 1107.02 417.151 1106.41 462.867Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.16 352.388L1028.93 354.009C1029.08 344.393 1029.23 334.789 1029.39 325.196L1059.6 323.32C1059.46 333.007 1059.31 342.696 1059.16 352.388Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.96 405.134L981.52 406.255C981.882 386.357 982.241 366.493 982.597 346.665L1011.97 345C1011.63 365.01 1011.29 385.054 1010.96 405.134Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.157 390.62L936.562 391.856C937.001 369.877 937.433 347.94 937.859 326.043L966.402 324.221C965.987 346.322 965.572 368.455 965.157 390.62Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.964 313.717L894.211 315.601C894.415 306.295 894.614 296.994 894.807 287.699L922.534 285.578C922.341 294.955 922.151 304.335 921.964 313.717Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.08 380.834L850.027 382.113C850.39 366.818 850.743 351.541 851.088 336.281L878.096 334.607C877.763 349.996 877.424 365.405 877.08 380.834Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.825 419.873L807.465 420.811C807.693 411.802 807.915 402.799 808.131 393.802L834.473 392.637C834.257 401.68 834.041 410.759 833.825 419.873Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.119 398.044L767.434 399.192C767.843 383.576 768.252 367.974 768.66 352.387L794.267 350.889C793.905 366.575 793.522 382.293 793.119 398.044Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.123 430.039L727.121 430.863C727.483 417.701 727.846 404.556 728.208 391.428L753.183 390.271C752.833 403.504 752.479 416.76 752.123 430.039Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.829 470.736L687.449 471.227C687.963 453.262 688.483 435.323 689.009 417.411L713.362 416.482C712.854 434.546 712.343 452.631 711.829 470.736Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.639 504.352L648.855 504.562C649.002 499.579 649.153 494.59 649.311 489.595L673.086 489.262L672.639 504.352Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.678 526.713H611.473C611.934 512.161 612.399 497.625 612.866 483.107L636.045 482.73C635.589 497.383 635.134 512.044 634.678 526.713Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.811 542.271L575.176 542.174C575.661 527.569 576.146 512.963 576.631 498.358L599.249 498.104C598.769 512.785 598.29 527.507 597.811 542.271Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.495 567.033L539.402 566.744C539.77 556.076 540.138 545.426 540.507 534.793H562.581C562.213 545.543 561.851 556.289 561.495 567.033Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.956 506.516L507.434 506.692C507.696 499.412 507.956 492.13 508.214 484.845L529.736 484.494C529.473 491.832 529.213 499.173 528.956 506.516Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.762 546.739L472.73 546.607C473.28 531.686 473.832 516.789 474.387 501.914L495.419 501.695C494.864 516.686 494.312 531.701 493.762 546.739Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.562 579.188L439.012 578.82L439.485 566.402L460.035 566.674L459.562 579.188Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.752 593.866L406.676 593.393C406.877 588.345 407.079 583.289 407.272 578.25L427.348 578.609C427.15 583.692 426.951 588.778 426.752 593.866Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.039 674.089L372.383 673.029C373.364 649.105 374.34 625.225 375.31 601.389L394.922 601.923C393.958 625.935 392.997 649.99 392.039 674.089Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.307 694.814L341.098 693.639C341.39 686.857 341.682 680.074 341.974 673.291L361.166 674.351C360.874 681.157 360.587 687.978 360.307 694.814Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.112 718.528L310.332 717.161L311.147 698.25L329.918 699.477C329.655 705.822 329.386 712.172 329.112 718.528Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.333 724.118L280.93 722.725L282.376 689.924L300.726 691.072C300.276 702.078 299.812 713.094 299.333 724.118Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.792 738.762L251.836 737.281C252.257 727.933 252.68 718.586 253.107 709.238L271.054 710.518L269.792 738.762Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.061 814.755L220.473 812.757L222.182 775.951L239.752 777.704C239.191 790.013 238.627 802.364 238.061 814.755Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.851 803.795L193.648 801.893L194.884 775.604L212.078 777.356C211.663 786.155 211.254 794.967 210.851 803.795Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.49 787.73L167.664 785.978C168.681 765.033 169.691 744.124 170.696 723.25L187.504 724.582C186.499 745.596 185.494 766.646 184.49 787.73Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.355 738.577L143.906 737.167C144.625 722.479 145.346 707.807 146.071 693.148L162.511 694.261C161.792 709.036 161.074 723.808 160.355 738.577Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.309 700.904L120.211 699.773L121.087 683.123L137.177 684.148C136.885 689.722 136.595 695.307 136.309 700.904Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.317 694.103L95.543 693.008L96.726 670.021L112.5 670.959C112.126 678.671 111.732 686.385 111.317 694.103Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1206 701.586L70.6797 700.465C71.2289 689.826 71.7839 679.199 72.3447 668.584L87.7769 669.46L86.1206 701.586Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4263 728.016L45.3359 726.728C45.6865 720.033 46.0399 713.344 46.3963 706.66L61.5217 707.817C61.1478 714.547 60.7827 721.28 60.4263 728.016Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6986 725.992L21.8711 724.739C22.5021 713.142 23.1272 701.56 23.7464 689.992L38.5652 691.026L36.6986 725.992Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.385 706.697L-0.144531 705.575C0.0482612 702.169 0.235198 698.758 0.416306 695.34L14.9371 696.4L14.385 706.697Z",
    fill: "#F5F5F5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-384.924 816.353L-388 813.873L-292.27 695.428L-228.35 793.349L-126.942 637.012L-12.1073 505.449L62.5735 625.997L146.535 553.796L258.731 734.013L317.953 623.648L447.895 477.871L524.487 338.613L568.583 434.746L694.617 291.765L793.055 124.044L839.615 198.313L920.807 44L965.236 113.51L1012.56 46.445L1155.35 449.101L1292.52 189.164L1355.79 294.937L1411.91 263.223L1412.93 264.712L1570.84 494.24L1679.88 381.019L1745.71 448.54L1907.93 216.917L1987.61 337.369L1984.31 339.56L1907.83 223.945L1746.22 454.718L1679.9 386.706L1570.32 500.471L1410.7 268.445L1354.38 300.274L1292.73 197.226L1154.64 458.924L1011.38 54.9629L965.07 120.6L921.131 51.8519L839.912 206.235L793.169 131.659L697.807 294.069L567.523 441.924L524.171 347.394L451.103 480.14L321.169 625.9L258.994 741.9L145.614 559.799L61.6445 632.008L-12.6507 512.082L-123.796 639.387L-228.342 800.596L-292.612 702.132L-384.924 816.353Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1841_321",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5423.41 415.463) rotate(-179.996) scale(5967.91 1912.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7000B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1841_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 830,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.2afd0ed61850e0d817d4b27250e898e5.svg";
export { ForwardRef as ReactComponent };